import { Layout } from 'antd';
import { FC, ReactNode } from 'react';

import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { ReactComponent as SparkleIcon } from 'images/chatbot/ai-assistant-button.svg';
import AppSider from 'layout/AppSider';
import {
  selectChatUIState,
  setVisible as setChatVisible,
} from 'modules/chatbot/slices/chatbotSlice';
import useBenguide from 'hooks/benguide';
import styles from './layout.module.less';

export type DefaultLayoutProps = {
  collapsed: boolean;
  setCollapsed: (collpased: boolean) => void;
  children: ReactNode;
};

const DefaultLayout: FC<DefaultLayoutProps> = (props: DefaultLayoutProps) => {
  const { collapsed, setCollapsed } = props;
  const isTablet = useAppSelector((state) => state.layout.isTablet);
  const dispatch = useAppDispatch();
  const { isVisible: isChatOpen } = useAppSelector(selectChatUIState);
  const { isAiAssistantChatEnabled } = useBenguide();

  return (
    <>
      {!isTablet && (
        <AppSider
          collapsed={collapsed}
          onCloseSider={() => setCollapsed(true)}
        />
      )}
      <Layout>{props.children}</Layout>
      {isTablet && (
        <AppSider
          collapsed={collapsed}
          onCloseSider={() => setCollapsed(true)}
        />
      )}
      {/* Floating chat icon for mobile view */}
      {!isChatOpen && isAiAssistantChatEnabled && (
        <div
          className={styles.floatingSparkleIcon}
          onClick={() => dispatch(setChatVisible(true))}
        >
          <SparkleIcon />
        </div>
      )}
    </>
  );
};

export default DefaultLayout;
